import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_awf1h1ea9q: FaireBrandEntity = {
  token: "b_awf1h1ea9q",
  type: "brand",
  name: "KeaBabies",
  avatarUrl:
    "https://cdn.faire.com/fastly/fcdaaf75269ff2cc70f53c4252da5301135c8813f00a55ce80b33ad1f032f387.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a996badf3ad0f496472b7e476523757f9412f2ef7d97ff33926e258d9cee5fc9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fcdaaf75269ff2cc70f53c4252da5301135c8813f00a55ce80b33ad1f032f387.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a996badf3ad0f496472b7e476523757f9412f2ef7d97ff33926e258d9cee5fc9.png",
  location: "CA, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 371,
  isTopShop: true,
  isInsider: true,
  description:
    "We are here to inspire you to cherish every bonding moment, while nurturing your child's full potential. Enjoy this awesome adventure. KeaBabies will walk with you! From our humble beginning in 2017, we have been putting our faith in the magic of parent-child bonding moments. KeaBabies, under our parent company KeaWorld, is now simplifying the lives of over 3 million parents in 13 countries. We are well on our way towards an ecosystem that offers a wide range of internationally certified baby and maternity products. You are welcome to join KeaCommunity – a platform for parents to connect. \n\n--\n\nOur promise to you\n\nWe offer unwavering quality, value and assurance with every purchase.\n\nCustomers are at the heart of everything we do. Each KeaBabies piece is thoughtfully researched, crafted and tested, because you and your little one deserve only the best. All of our products are gentle, internationally-certified, and made with the best materials, too. Your purchase is worry-free, with the assurance of our KeaCare 365-day money-back warranty.\n\nYour KeaBabies product is covered with KeaCare 365-day money-back warranty. \n\nFor any questions about our products or product samples, email us [redacted-email].",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:19.530Z",
    importedBy: "entity-db-cli",
  },
};
